// extracted by mini-css-extract-plugin
export default {"cls1":"MjwmHleVBZwNFbEEWMEz","cls2":"lUqJYaXwZIcQgAEGcF2T MjwmHleVBZwNFbEEWMEz","warning":"I4gprQ7tCNBOPp9tJ_gR"};